<script>

export default {
  props: {
    users: {
      type: Array,
      default: function() {
        return [];
      }
    },
    selectUser: {
      type: Function
    }
  },
  data() {
    return {
      fields: [
        { key: 'email', sortable: false, label: 'E-mail' },
        { key: 'name', sortable: false, label: 'Nome' },
        { key: 'document_number', sortable: false, label: 'CPF/CNPJ' },
        { key: 'phone_number', sortable: false, label: 'Telefone' },
        { key: 'birthdate', sortable: false, label: 'Data Nascimento' },
        { key: 'created_at', sortable: false, label: 'Data Cadastro', formatter: (value) => {
          return this.$moment(value).format('DD/MM/YYYY HH:mm:ss');
        } },
        { key: 'last_login_at', sortable: false, label: 'Último Acesso', formatter: (value) => {
          if (value) {
            return this.$moment(value).format('DD/MM/YYYY HH:mm:ss');
          }

          return '';
        } },
        { key: 'confirmed', label: 'Status' },
        { key: 'actions', label: '', class: 'nowrap-col' },
      ],
    };
  },
  methods: {
    formatDate(date) {
      return this.$moment(date).format('DD/MM/YYYY');
    },
  }
};
</script>

<template>
  <div class="table-responsive mb-0">
     <b-table
      show-empty
      emptyText="Nenhum registro para exibir"
      :items="users"
      :fields="fields"
      responsive="sm"
      head-variant="light"
    >
      <template v-slot:cell(actions)="row">
        <b-dropdown class="card-drop" variant="white" right toggle-class="p-0">
          <template v-slot:button-content>
            <i class="mdi mdi-dots-horizontal font-size-18"></i>
          </template>

          <b-dropdown-item @click="selectUser(row.item, 'block')" v-if="!row.item.blocked">
            <i class="fas fa-ban text-danger mr-2 mt-2"></i> Bloquear Acesso
          </b-dropdown-item>

          <b-dropdown-item @click="selectUser(row.item, 'unblock')" v-if="row.item.blocked">
            <i class="fas fa-check text-success mr-2 mt-2"></i> Desbloquear Acesso
          </b-dropdown-item>

          <b-dropdown-item @click="selectUser(row.item, 'show-password')" v-if="row.item.temp_password">
            <i class="fas fa-eye text-primary mr-2 mt-2"></i> Visualizar Senha Temporária
          </b-dropdown-item>

          <b-dropdown-item @click="selectUser(row.item, 'recover-password')">
            <i class="fas fa-unlock text-warning mr-2 mt-2"></i> Enviar Recuperação de Senha
          </b-dropdown-item>
        </b-dropdown>
      </template>

      <template v-slot:cell(confirmed)="row">
        <span
          class="badge badge-pill badge-soft-primary font-size-12"
          :class=" {
            'badge-soft-success': !row.item.blocked,
            'badge-soft-danger': row.item.blocked,
          }"
        >{{row.item.blocked ? 'Bloqueado' : 'Ativo'}}</span>
      </template>
      <!-- <template v-slot:cell(statusDescription)="row">
        <span
          class="badge badge-pill badge-soft-primary font-size-12"
          :class=" {
            'badge-soft-danger': row.item.status === 'canceled',
            'badge-soft-success': row.item.status === 'new',
            'badge-soft-secondary': row.item.status === 'completed',
          }"
        >{{row.item.statusDescription}}</span>
      </template>

      <template v-slot:cell(customer)="row">
        {{row.item.customer.name ? row.item.customer.name : 'Nome do Cliente'}}
        <span v-if="row.item.tags && row.item.tags.first_sale" class="badge badge-pill badge-soft-primary font-size-10">Primeira Compra</span>
      </template>

      <template v-slot:cell(shipping)="row">
        {{row.item.shipping.shipping_option ? row.item.shipping.shipping_option.description : ''}}
        <p v-if="row.item.shipping.schedule" class="text-muted mb-0 mt-1 font-size-10">{{formatDate(row.item.shipping.schedule.date)}} {{row.item.shipping.schedule.description}}</p>
      </template>

      <template v-slot:cell(actions)="row">
        <b-dropdown class="card-drop" variant="white" right toggle-class="p-0">
          <template v-slot:button-content>
            <i class="mdi mdi-dots-horizontal font-size-18"></i>
          </template>

          <router-link :to="'/sales/detail/' + row.item._id">
            <b-dropdown-item href="javascript: void(0);">
              <i class="fas fa-shopping-cart text-primary mr-2 mt-2"></i>
              Detalhes do Pedido
            </b-dropdown-item>
          </router-link>

          <b-dropdown-item v-b-modal.modal-remove @click="download(row.item)">
            <i class="fas fa-download text-info mr-2 mt-2"></i> Via do Pedido (PDF)
          </b-dropdown-item>
        </b-dropdown>
      </template> -->
    </b-table>
  </div>  
</template>